import { normalizeUser, Input } from './user';

export function normalizeMe(input: Input) {
  const user = normalizeUser(input);
  return { ...user } as const;
}

export type Me = ReturnType<typeof normalizeMe>;
